// src/api/file.ts

import type { PresignedResponse } from '@/types/file';
import api from './client';

/**
 * Uploads a file to a presigned URL.
 */
export async function uploadFileToS3(
  file: File,
  presignedUrl: string
): Promise<void> {
  await fetch(presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
}

/**
 * Fetch presigned URL from backend. The server picks the key, under the
 * caller's own folder in `companyId` (the company the portal works in);
 * `destination` is no longer used for the key.
 */
export async function getPresignedUrl({
  companyId,
  ...params
}: {
  filename: string;
  destination: string;
  companyId?: string | null;
  /** Size in bytes of the file about to be PUT; the URL then refuses any other size. */
  size?: number;
}): Promise<PresignedResponse> {
  const res = await api.post<{ message: string; data: PresignedResponse }>(
    '/s3/presigned-url',
    { ...params, ...(companyId ? { companyId } : {}) }
  );
  return res.data.data;
}
